import type { STATIC_FILTER_ENTITY_TYPES } from '@shared/features/views/components/entities-filters/config';
import type { TCustomField } from '@shared/types/custom-field';
import type { TCustomFieldFilter } from './custom-field-filter';
import type { TDynamicFilter } from './dynamic-filter';
import type { TField } from '@shared/types/field';
import type { TMember } from '@shared/types/member';
import type { TOrganization } from '@shared/types/organization';
import type { ValueOf } from '@shared/types/utilities';
import type {
  ColumnPinningState,
  ColumnSizingState,
  VisibilityState,
  ColumnOrderState,
  SortingState,
} from '@tanstack/react-table';

export const VIEW_ENTITIES = {
  application: 'APPLICATION',
  program: 'PROGRAM',
  lead: 'LEAD',
  task: 'TASK',
  product: 'PRODUCT',
  invoice: 'INVOICE',
  payment: 'PAYMENT',
  placement: 'PLACEMENT',
  stage: 'STAGE',
} as const;

export type TView = {
  id: number;
  organization: TOrganization;
  created_by: TMember;

  filters: TDynamicFilter[];
  custom_filters: TCustomFieldFilter[];
  static_filters: {
    entityType?: ValueOf<typeof STATIC_FILTER_ENTITY_TYPES>;

    field: string;
    friendlyField?: string;

    value: (string | number | null)[];
    friendlyValue?: string[];
  }[];

  visible_fields: TField[];
  visible_custom_fields: TCustomField[];
  visible_static_fields: {
    visibility?: VisibilityState;
    ordering?: ColumnOrderState;
    pinning?: ColumnPinningState;
    sizing?: ColumnSizingState;
    sorting?: SortingState;
    names?: Record<string, string | null>;
  };

  entity_type: ValueOf<typeof VIEW_ENTITIES>;
  entity_id: number;

  name: string;
  description: string;

  is_default: boolean;
  is_public: boolean;

  created_at: string;
  updated_at: string;
};
